<div class="container-xl py-3 company-page">
  <nav class="crumbs">
    <button type="button" class="link-btn" (click)="goBackToCompanies()"><i class="bi bi-arrow-left me-1"></i>Aziende</button>
    <ng-container *ngIf="isEditMode && company">
      <span>›</span><span class="text-body fw-medium">{{ company.name }}</span>
    </ng-container>
  </nav>

  <ng-container *ngIf="isEditMode; else createTpl">
    <ng-container *ngIf="company">
      <!-- Intestazione -->
      <section class="fh-card header-card">
        <div class="d-flex align-items-center gap-3 flex-grow-1 min-w-0">
          <img *ngIf="company.logoUrl; else initialsTpl" [src]="company.logoUrl" alt="Logo {{ company.name }}" class="avatar logo" />
          <ng-template #initialsTpl><div class="avatar">{{ initials }}</div></ng-template>
          <div class="min-w-0">
            <div class="d-flex flex-wrap align-items-center gap-2">
              <h1 class="h4 fw-semibold mb-0 text-truncate">{{ company.name }}</h1>
              <span class="chip" [ngClass]="company.passive ? 'chip-muted' : 'chip-success'">
                {{ company.passive ? 'Inattiva' : 'Attiva' }}
              </span>
            </div>
            <div class="meta">
              <span>Hubspot ID <span class="mono text-body">{{ company.id }}</span></span>
              <span>P.IVA <span class="mono text-body">{{ company.vatNumber || '—' }}</span></span>
              <span>{{ sizeLabel(company.size) }}</span>
            </div>
          </div>
        </div>
        <div class="kpis">
          <div class="kpi">
            <div class="label">Servizi collegati</div>
            <div class="value">{{ summary?.services ?? '–' }}</div>
            <div class="sub">{{ summary ? summary.activeServices + ' attivi' : '' }}</div>
          </div>
          <div class="kpi">
            <div class="label">Prodotti</div>
            <div class="value">{{ summary?.products ?? '–' }}</div>
            <div class="sub">nei servizi collegati</div>
          </div>
          <div class="kpi">
            <div class="label">Prezzi</div>
            <div class="value">{{ summary ? summary.prices + summary.rules : '–' }}</div>
            <div class="sub">{{ summary ? summary.rules + ' in convenzione · ' + summary.prices + ' di listino' : '' }}</div>
          </div>
        </div>
      </section>

      <!-- Tab -->
      <div class="tabs">
        <button type="button" [class.on]="tab === 'servizi'" (click)="tab = 'servizi'">
          <i class="bi bi-diagram-3 me-2"></i>Servizi e prodotti
        </button>
        <button type="button" [class.on]="tab === 'anagrafica'" (click)="tab = 'anagrafica'">
          <i class="bi bi-building me-2"></i>Anagrafica
        </button>
      </div>

      <!-- Il catalogo resta montato cambiando tab, così non viene ricaricato. -->
      <div [hidden]="tab !== 'servizi'">
        <app-b2b-company-catalog [company]="company" (summaryChange)="summary = $event"></app-b2b-company-catalog>
      </div>
      <div *ngIf="tab === 'anagrafica'">
        <ng-container *ngTemplateOutlet="companyFormTpl"></ng-container>
      </div>
    </ng-container>

    <div *ngIf="!company" class="fh-card p-5 text-center text-muted-fh">
      <span class="spinner-border spinner-border-sm me-2"></span>Carico l'azienda…
    </div>
  </ng-container>

  <ng-template #createTpl>
    <h1 class="h4 fw-semibold mb-3">Crea azienda</h1>
    <ng-container *ngTemplateOutlet="companyFormTpl"></ng-container>
  </ng-template>
</div>

<!-- Anagrafica: stesso form per creazione e modifica -->
<ng-template #companyFormTpl>
  <section class="fh-card">
    <form [formGroup]="companyForm" class="row g-4 p-4" (ngSubmit)="saveCompany()">
      <div class="col-sm-6">
        <label for="id" class="form-label">Hubspot ID azienda</label>
        <input type="text" id="id" class="form-control" formControlName="id" [readonly]="isEditMode" />
        <span class="hint" *ngIf="isEditMode">Non modificabile dopo la creazione</span>
        <div *ngIf="(companyForm.get('id')?.touched && companyForm.get('id')?.errors) || formInvalid">
          <span class="form-error">{{ validatorErrorMessage('id') }}</span>
        </div>
      </div>
      <div class="col-sm-6">
        <label for="name" class="form-label">Nome azienda</label>
        <input type="text" id="name" class="form-control" formControlName="name" />
        <div *ngIf="(companyForm.get('name')?.touched && companyForm.get('name')?.errors) || formInvalid">
          <span class="form-error">{{ validatorErrorMessage('name') }}</span>
        </div>
      </div>
      <div class="col-sm-6">
        <label for="vatNumber" class="form-label">Partita IVA</label>
        <input type="text" id="vatNumber" class="form-control" formControlName="vatNumber" />
      </div>
      <div class="col-sm-6">
        <label for="size" class="form-label">Dimensione azienda</label>
        <select class="form-select" id="size" formControlName="size">
          <option [ngValue]="null" disabled>Seleziona</option>
          <option *ngFor="let size of sizes" [ngValue]="size.value">{{ size.label }}</option>
        </select>
        <div *ngIf="(companyForm.get('size')?.touched && companyForm.get('size')?.errors) || formInvalid">
          <span class="form-error">{{ validatorErrorMessage('size') }}</span>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="d-flex align-items-center justify-content-between border rounded-3 px-3 py-2 h-100">
          <div>
            <div class="fw-medium small">Azienda inattiva</div>
            <div class="hint">I dipendenti non possono più registrarsi né fare richieste</div>
          </div>
          <div class="form-check form-switch m-0">
            <input class="form-check-input" type="checkbox" role="switch" id="passive" formControlName="passive" aria-label="Azienda inattiva" />
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <label for="logo" class="form-label">Logo</label>
        <div class="d-flex align-items-center gap-3">
          <img *ngIf="companyForm.get('logoUrl')?.value" [src]="companyForm.get('logoUrl')?.value" alt="Logo azienda" class="company-logo" />
          <input type="file" id="logo" class="form-control" accept="image/*" (change)="onFileSelected($event)" />
        </div>
        <span class="hint" *ngIf="!companyForm.get('id')?.value">Inserisci prima l'Hubspot ID</span>
      </div>
    </form>
    <div class="form-foot">
      <button *ngIf="isEditMode" type="button" class="danger-link" (click)="deleteCompany()">
        <i class="bi bi-trash3 me-1"></i>Elimina azienda
      </button>
      <span *ngIf="!isEditMode"></span>
      <button type="button" class="btn btn-primary text-light" (click)="saveCompany()">
        <i class="bi bi-floppy-fill text-light me-1"></i>{{ isEditMode ? 'Salva anagrafica' : 'Crea azienda' }}
      </button>
    </div>
  </section>
</ng-template>

<app-alert
  *ngIf="showDeleteConfirm"
  (save)="confirmDelete($event)"
  [data]="{ type: undefined }"
  [title]="'Conferma eliminazione'"
  [message]="'Sei sicuro di voler eliminare l\'azienda ' + company?.id + '?'"
>
</app-alert>
